// AI-powered search types
export const AI_QUERY_TYPES = ['LLM', 'VAAS'];
// Type guard to identify AI-powered searches
export const isAiQueryType = type => AI_QUERY_TYPES.includes(type);

// Sort field for maintaining AI result order
export const ORDERED_LISTING_ID = 'ORDERED_LISTING_ID';
export const ASC = 'ASC';